import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";
import { ToastContainer } from "react-toastify";


const Home = lazy(() => import("../../Pages/Home"));
const Instances = lazy(() => import("../../Pages/Instances"));
const NewHealthcheck = lazy(() => import("../../Pages/NewHealthcheck"));
const Telemetry = lazy(() => import("../../Pages/Telemetry"));
const LicenseManagement = lazy(() => import("../../Pages/LicenseManagement"));
const Logging = lazy(() => import("../../Pages/Logging"));
const Notifications = lazy(() => import("../../Pages/Notifications"));
const Identities = lazy(() => import("../../Pages/Identities"));
const ServicesData = lazy(() => import("../../Pages/ServicesData"));
const EmmaABS = lazy(() => import("../../Pages/EmmaABS"));


const AppMain = (parameters) => {
    return (
        <Fragment>

            {/* Home */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/home" component={Home}/>
            </Suspense>

           

            {/* Instances */}
            {'instances' in parameters["permissions"] && parameters["permissions"]['instances']['permit'] != 'NONE' ?
            // {parameters["permissions"][0] != "None" ?
             <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/instances" component={Instances}/>
            </Suspense> 
             : null} 

            {/* Healthcheck */}
            {/* {('monitorization' in parameters["permissions"] && parameters["permissions"]['monitorization']['permit'] != "NONE" && (parameters["permissions"]['monitorization']['sections'].includes('healthcheck'))) ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/healthcheck" render={routeProps => <Healthcheck selected_instance_id={parameters.selected_instance_id} updateInstance={parameters.updateInstance} {...routeProps}/>}/>
            </Suspense>
            : null} */}

            {/* New Healthcheck */}
            {('monitorization' in parameters["permissions"] && parameters["permissions"]['monitorization']['permit'] != "NONE" && (parameters["permissions"]['monitorization']['sections'].includes('healthcheck'))) ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/healthcheck" render={routeProps => <NewHealthcheck selected_instance_id={parameters.selected_instance_id} updateInstance={parameters.updateInstance} {...routeProps}/>}/>
            </Suspense>
            : null}

              {/* Telemetry */}
              {('monitorization' in parameters["permissions"] && parameters["permissions"]['monitorization']['permit'] != "NONE" && (parameters["permissions"]['monitorization']['sections'].includes('telemetry'))) ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/telemetry" render={routeProps => <Telemetry selected_instance_id={parameters.selected_instance_id} updateInstance={parameters.updateInstance} {...routeProps}/>}/>
            </Suspense>
            : null}

{/* component={routeProps => <Telemetry title={`Props through component`} {...routeProps}/>} */}

            {/* LicenseManagement */}
            {('licenses' in parameters["permissions"] && parameters["permissions"]['licenses']['permit'] != "NONE") ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/licensemanagement" component={LicenseManagement}/>
            </Suspense>
            : null}

            {/* Logging */}
            
            {('logging' in parameters["permissions"] && parameters["permissions"]['logging']['permit'] != "NONE") ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/logging" component={Logging}/>
            </Suspense>
            : null}

            {/* Notifications */}
            {('notifications' in parameters["permissions"] && parameters["permissions"]['notifications']['permit'] != "NONE") ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/management/notifications" component={Notifications}/>
            </Suspense>
            : null}

            {/* Roles */}
            {('identities' in parameters["permissions"] && parameters["permissions"]['identities']['permit'] != "NONE") ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/management/identities" component={Identities}/>
            </Suspense>
            : null}

            {/* Business Data */}
            
            {('business' in parameters["permissions"] && parameters["permissions"]['business']['permit'] != "NONE") ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/business" render={routeProps => <ServicesData selected_instance_id={parameters.selected_instance_id} updateInstance={parameters.updateInstance} {...routeProps}/>}/>
            </Suspense>
            : null}

             {/* EmmaABS*/}
            
             {('emmaabs' in parameters["permissions"] && parameters["permissions"]['emmaabs']['permit'] != "NONE") ?
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Loading...
                        </h6>
                    </div>
                </div>
            }>
                <Route path="/emmaabs" render={routeProps => <EmmaABS selected_instance_id={parameters.selected_instance_id} selected_agrupation={parameters.selected_agrupation} selected_council={parameters.selected_council} updateInstance={parameters.updateInstance} updateSelectedAgrupation={parameters.updateSelectedAgrupation} updateSelectedCouncil={parameters.updateSelectedCouncil} {...routeProps}/>}/>
            </Suspense>
            : null}

            <Route exact path="/" render={() => (
                <Redirect to="/home/dashboard"/>
            )}/>
            <ToastContainer/>
        </Fragment>
    )
};

export default AppMain;
